// extracted by mini-css-extract-plugin
export var closeButton = "_la-1";
export var closeX = "_la-3";
export var container = "_la-0";
export var image = "_la-2";